import React from 'react';
import {IsLP_MP_SP} from "my-styles/media/media";
import {Divider} from "@material-ui/core";
import Space from "../../../components/space/Space";
import messages from "res/messages/farsi";

import ICAggrementDesktop from 'res/images/aggrement_desktop.png';
import ICAggrementMobile from 'res/images/aggrement_mobile.png';

export default function Aggrement() {

    function title() {
        return <>
            <div className="largeTextBold">
                {messages.roleAndCondition + messages.sarfeMarket}
            </div>
            <Space height={"1em"}/>
            <Divider/>
            <Space height={"1.5em"}/>
        </>
    }

    if (IsLP_MP_SP()) {
        return (
            <div className="horizontalScreen marginSmall paddingSmall">
                <div style={{width: "60%"}}>
                    {title()}
                    <div className="justify largeText">
                        {messages.aggrementText}
                    </div>
                </div>
                <div style={{width: "40%"}}>
                    <img className="image" src={ICAggrementDesktop} alt=""/>
                </div>
            </div>
        )
    } else {
        return (
            <div className="center marginSmall">
                <img className="twoFromThree" src={ICAggrementMobile} alt=""/>
                {title()}
                <div className="marginSmall paddingSmall justify largeText">
                    {messages.aggrementText}
                </div>
            </div>
        )
    }
}